import { memo } from "react";
import { Navigate, useParams } from "react-router-dom";

const DcvRedirectWrapper = memo(function DcvRedirectWrapper(): JSX.Element {
  const { code } = useParams();

  return (
    <Navigate
      to={`/organization/settings/general?code=${code ?? ""}`}
      replace
    />
  );
});

export default DcvRedirectWrapper;
